import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch } from "hooks/hooks";
import { FormatDate, FormatDateShort, FormatTime } from "utils/dateUtils";
import { IReport } from "../domain/IReport";
import { setDeleteReportModalOpen } from "../reports.slice";

interface IProps {
  report: IReport;
  index: number;
  isLast: boolean;
  lastElementRef: any;
};

const Report = ({ report, index, isLast, lastElementRef }: IProps) => {
  const dispatch = useAppDispatch();

  return (
    <div
      ref={isLast ? lastElementRef : undefined}
      className="report-item"
    >
      <div className="report-item-header">
        <span className="user">{report.senderName}</span>,
        <span className="title">{report.projectName}</span> (
        <span className="date-time">{`${FormatDateShort(report.dateTimeCreate)}, ${FormatTime(report.dateTimeCreate)}`}</span>
        {report.dateTimeUpdate &&
          <span className="date-time">{` - ${FormatTime(report.dateTimeUpdate)}`}</span>})
      </div>
      <div className="body">
        <p>IZVEŠTAJ RADOVA ZA {FormatDate(report.dateTimeCreate)}</p>
        <br />
        <p>{report.text}</p>
      </div>
      <button className="close-button"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(setDeleteReportModalOpen({ visible: true, index }));
        }}
      >
        <FontAwesomeIcon icon={faTimesCircle} />
      </button>
    </div>
  );
};

export default Report;
